module.exports = __webpack_public_path__ + "static/media/falkland-islands.8d68cf94.svg";